export const partners=[
    {
        "id":"1",
        "email":"crispinaNavarro2020@gmail.com",
        "name":"Crispina Navarro",
        "brand":"Crispina Navarro",
        "picture":"",
        "description":' Originaria de Santo Tomás Jalieza, una comunidad como muchas de Oaxaca que dependen de la producción artesanal. Desde los seis años, comencé a tejer en telar de cintura, con el paso de los años adquirí la destreza y sabiduría que sólo otorga el tiempo.',
        "permission":"partner",
        "address":{
            "calle": "38",
            "exterior": "58",
            "interior": "3",
            "colonia": "Centro",
            "municipio": "Izamal",
            "estado": "Yucatán",
            "cp": "97540",
            "referencia": "Entre calle Benito Juárez e Independencia. Casa color rojo con zaguán negro."
        },
        "networks":{
            "facebook":"https://www.facebook.com/gabrielpj",
            "instagram":"https://www.instagram.com/gabrielpj",
            "pageweb":"https://www.artesgabrielperez.com"
        },
        "payment":"",
        "region":"",
        "technique":"",

        "salehistory":{
            "saledate":"",
            "product":"",
            "units":"",
            "total":"",
            "shippingstatus":""
        }
    },
    {
        "id":"2",
        "email":"",
        "name":"",
        "brand":"",
        "picture":"",
        "description":"",       
        "permission":"partner",
        "address":{
            "calle": "",
            "exterior": "",
            "interior": "",
            "colonia": "",
            "municipio": "",
            "estado": "",
            "cp": "",
            "Referencias":""
        },
        "networks":{
            "facebook":"",
            "instagram":"",
            "pageweb":""
        },
        "payment":"",
        "region":"",
        "technique":"",

        "salehistory":{
            "saledate":"",
            "product":"",
            "units":"",
            "total":"",
            "shippingstatus":""
        }
    }
]

/* pedido=[{
    "id":"1",
    "name":"Nacimiento con arca de Noé",
    "description":"Madera de cedro tallada y policromada al pincel",
    "price": "$5000",
    "descuento": "",
    "envio":"400",
    "total":"",
}] */
/* 
products=[{
    "id":"",
    "name":"",
    "picture":"",
    "descriptio":"",
    "region":"",
    "technique":"",
    "price":"",
    "unitsavailable":"",
    "category":"",
}]

customers=[
    {
    "id":"1",
    "email":"magdalenaenriquez76@gmail.com",
    "name":"Magdalena Enríquez Correa",
    "paymentmethod":"MasterCard terminación 3216 - 7/2025",
    "address":{
            "calle": "San Jerónimo",
            "exterior": "89",
            "interior": "",
            "colonia": "San Jerónimo Lídice",
            "municipio": "Magdalena Contreras",
            "estado": "Ciudad de México",
            "cp": "10200",
            "Referencias":"Casa color blanco con puerta de madera. Entre calle Porfirio Díaz y Magnolia"
        },
    "permission":"client",

    "purchasehistory":{
        "purchasedate":"",
        "ordernumber":"",
        "product":"",
        "shippingstatus":""
    }
}]

administrators=[{
    "id":"",
    "email":"",
    "name":"",
    "permission":"adm",
}] */